import { JOB_STATUS_ACTIVE } from "@/lib/constants";

// Shows a pulsing green "Live" badge ONLY when the job status is exactly Active.
// Never renders for Draft / Paused / Closed / Archived.
export const LiveBadge = ({ status, className = "" }) => {
  if (status !== JOB_STATUS_ACTIVE) return null;
  return (
    <span
      data-testid="job-live-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 ${className}`}
    >
      <span className="live-dot" aria-hidden="true" />
      Live
    </span>
  );
};
